/**
 * @Author:
 * @Description:
 * @DateTime: Created in 9:44 2018/11/26
 */
import Api from '../../../util/api';
import { Result, ResultPageDo } from '../../../types/base';
import { DateTimeUtil } from 'src/util/dateTimeUtil';

export declare namespace IndexPageDOI {
    export interface OverproofStationI {
        component_name: string;
        device_name: string;
        value: string;
    }
    export interface SearchMonitoringRankingParamsI {
        source_pollution_sort_front?: number;
        source_pollution_sort_queen?: number;
        surfacewater_sort_front?: number;
        surfacewater_sort_queen?: number;
    }
    export interface MonitoringRankingRowI {
        source_pollution_sort_front: RankingRowI[];
        source_pollution_sort_queen: RankingRowI[];
        surfacewater_sort_front: RankingRowI[];
        surfacewater_sort_queen: RankingRowI[];
    }
    export interface RankingRowI {
        key: string;
        name: string;
        data: { device_name: string; value: number }[];
    }

    export interface MalfunctionStationRowI {
        component: string
        device_name: string
        'i12031-Info': string
    }
}
export default class IndexPageApi {
    /**
     * 查询代办列表
     * @param params
     */
    static async searchOverproof(type: number): Promise<Result<{ overproof_count: number; severity_count: number; normal_count: number }>> {
        return Api.post('/monitor/condition/distribution/overproof', { type });
    }

    static async searchOverproofStation(
        type: number,
        page_index: number,
        page_size: number,
    ): Promise<ResultPageDo<IndexPageDOI.OverproofStationI[]>> {
        return Api.post('/monitor/site/overproof', { type, page_index, page_size });
    }

    static async searchMonitoringRanking(
        params: IndexPageDOI.SearchMonitoringRankingParamsI,
    ): Promise<Result<IndexPageDOI.MonitoringRankingRowI>> {
        return Api.post('/monitor/monitoring_ranking/different_component', params);
    }

    static async searchMalfunctionStation(
        type: number,
        page_index: number,
        page_size: number,
    ): Promise<ResultPageDo<IndexPageDOI.MalfunctionStationRowI[]>> {
        //获取当月时间
        // var now = new Date();
        // var nowYear = now.getFullYear();
        // var nowMonth = now.getMonth();
        // return Api.post('/monitor/site/list/malfunction', { type, page_index, page_size, 
        //     end_time: DateTimeUtil.getSecondFromIviewDate(new Date(nowYear, nowMonth+1, 0, 23, 59)),
        //     start_time: DateTimeUtil.getSecondFromIviewDate(new Date(new Date(nowYear, nowMonth,0)))});
        //获取当天时间
        var now = new Date();
        var nowYear = now.getFullYear();
        var nowMonth = now.getMonth();
        return Api.post('/monitor/site/list/malfunction', { type, page_index, page_size, 
            end_time: DateTimeUtil.getSecondFromIviewDate(new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)),
            start_time: DateTimeUtil.getSecondFromIviewDate(new Date(new Date(new Date().toLocaleDateString()).getTime()))});
    }
}
